import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation  } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import adminRoutes from './routes/adminRoutes';
import customerRoutes from './routes/customerRoutes';
import authRoutes from './routes/authRoutes';

const RoleBasedRoutes = ({ user }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const location = useLocation();

  useEffect(() => { 
    const token = sessionStorage.getItem('token');
    const token_expiry = sessionStorage.getItem('token_expiry');

    if (location.pathname === "/register") return;

    if (!token || (token_expiry && Date.now() > token_expiry)) {
      logout(navigate);
      navigate('/login');
    }
  }, [logout, navigate, location.pathname]);

  const getRoutes = () => {
    if (!user) return authRoutes;
    if (user.role === 'Admin') return adminRoutes;
    if (user.role === 'Customer') return customerRoutes;
    return [];
  };

  return (
    <Routes>
      {getRoutes().map(({ path, element }, index) => (
        <Route key={index} path={path} element={element} />
      ))}
    </Routes>
  );
};

export default RoleBasedRoutes;